import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AnalyzerToken } from '@libs/shared/api';

@Component({
  selector: 'app-analyze-token-renderer',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  template: `
    @for (token of tokens; track token; let isLast = $last) {
      <span
        [ngClass]="[
          getTokenColor(token.type),
          getTextSize(),
          getLineBreakClass(),
        ]"
        matTooltip="{{ token.type }}">
        {{ token.token }}{{ isLast ? '' : ', ' }}
      </span>
    }
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyzeTokenRendererComponent {
  @Input() tokens: AnalyzerToken[];
  @Input() textSize: 'small' | 'medium' | 'large' = 'medium'; // Default size
  @Input() lineBreak = false; // Default to false

  getTokenColor(type: string): string {
    switch (type) {
      case 'word':
        return 'text-green-600 dark:text-green-400';
      case 'SYNONYM':
        return 'text-red-600 dark:text-red-400';
      default:
        return 'text-yellow-600 dark:text-yellow-400';
    }
  }

  getTextSize(): string {
    switch (this.textSize) {
      case 'small':
        return 'text-sm';
      case 'medium':
        return 'text-base';
      case 'large':
        return 'text-lg';
      default:
        return 'text-base';
    }
  }

  getLineBreakClass(): string {
    return this.lineBreak ? 'block' : '';
  }
}
